// extracted by mini-css-extract-plugin
export var filterIncDec = "_bz-0";
export var leftBorder = "_bz-1";
export var rightBorder = "_bz-2";
export var stringInput = "_bz-3";